@import '../../styles/modals.css';
@import '../../styles/buttons.css';

.space-info-modal {
  max-width: unset;
  width: 350px;
}

.space-info-modal .tambr-modal-body {
  background-color: #ffffff;
  color: #232329;
  min-height: 180px;
  overflow-x: hidden;
}

.tambr-arrow-button .close {
  stroke-width: 2px;
  width: 16px;
  height: 16px;
}

.tambr-dialog-close {
  --arrow-button-size: 30px;
  position: absolute;
  top: -10px;
  right: -10px;
}

.tambr-modal-window {
  overflow: unset;
  position: relative;
}

.space-info-modal .tambr-modal-body {
  overflow: unset;
  border-radius: 5px;
}